import { useContext } from 'react';
import { SidePanelUiContext } from '@/core/deep-dive/contexts/side-panel-provider';

export function useAppPin(appId: string) {
  const sidePanelUi = useContext(SidePanelUiContext);
  const isPinned = sidePanelUi.pinnedAppIds.includes(appId);

  const togglePin = () => {
    sidePanelUi.setPinnedAppIds(
      isPinned
        ? sidePanelUi.pinnedAppIds.filter(id => id !== appId)
        : [...sidePanelUi.pinnedAppIds, appId],
    );
  };

  return { isPinned, togglePin };
}
